angular.module("app").controller("MediasListPageController", [
    '$scope',
    '$uibModal',
    '$timeout',
    'mediaService',
    'errorHandler',
    'logger',
    'preloadedImages',
    'pageStatuses',
    'pagination',
    'Utils',
    function ($scope, $modal, $timeout, mediaService, errorHandler, logger, preloadedImages, pageStatuses, pagination, Utils) {

        $scope.pageStatuses = pageStatuses;
        $scope.filterOptions = {
            status: $scope.pageStatuses[0],
            selectedItems: [],
            isMultiselect: false
        };
        $scope.images = angular.copy(preloadedImages.items || []);
        $scope.pagination = pagination.init(function () {$scope.updateList()}, preloadedImages.total_count);


        /*
        *@ngdoc lisener
        *@name mediasList.updateImages
        *@description When you want to update page in Media view using $broadcast or $emit
        * */
        $scope.$on('mediasList.updateImages', function () {
            $scope.updateList();
        });

         /*
           *@ngdoc method
           *@name updateListFilter
           *@description updateListFilter functional is made to make "Select" and "Search" logics work
         */
        $scope.updateListFilter = function () {
            $scope.updateList()
        };

        /*
            *@ngdoc method
            *@name updateList
            *@description When you want to update page in Media view
        */
        $scope.updateList = function () {
            var requestOptions = {
                status: $scope.filterOptions.status,
                limit: $scope.pagination.limit,
                current_page: $scope.pagination.page
            };
            mediaService.getImages(requestOptions).then(
                function (response) {
                    if (response.status === "ok") {
                        $scope.images = angular.copy(response.items);
                        $scope.pagination.totalItems = response.total_count
                    } else {
                        errorHandler(response.message)
                    }
                },
                function (response) {
                    errorHandler(response.message)
                }
            )
        };

        /*
       *@ngdoc method
       *@name addMedia
       *@description When you want to open Media popup and add image
        */
        $scope.addMedia = function () {
            $modal.open({
                templateUrl: "views/media/add.html",
                controller: "AddMediaPageController",
                resolve: {
                    status: function () {
                        return $scope.filterOptions.status;
                    }
                }
            });
        };

        /*
       *@ngdoc method
       *@name changeImageItem
       *@description When you want to change image status ` publish or delete
       *@param {id} image id (string)
       *@param {status} this moment image status.(string)
        */
        $scope.changeImageItem = function (id, status) {
            var modalInstance = $modal.open({
                templateUrl: $scope.filterOptions.status === 'published' ? "views/templates/modals/confirmDeleteAction.html" : "views/templates/modals/confirmPublishAction.html",
                controller: "ConfirmDeleteActionModalController"
            });
            modalInstance.result.then(function () {
                mediaService.changeImageStatus({id: id, status: status === 'published' ? 'archive' : 'published'}).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.filterOptions.status === 'published' ? logger.logSuccess("media.imageUploaded") : logger.logSuccess("Image has been successfully publish");
                            $scope.updateList()
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            })
        };

        /**
         * Toggle multiselect mode
         */
        $scope.toggleMultiselect = function toggleMultiselect() {
            $scope.filterOptions.isMultiselect = !$scope.filterOptions.isMultiselect;
            if (!$scope.filterOptions.isMultiselect) {
               $scope.filterOptions.selectedItems.length = 0;
            }
        };

        /**
         * Changed selected items status
         */
        $scope.changeSelectedItems = function changeSelectedItems() {
            if ($scope.filterOptions.selectedItems.length === 0) {
                return;
            }
            var modalInstance = $modal.open({
                templateUrl: $scope.filterOptions.status === 'published' ? "views/templates/modals/confirmDeleteAction.html" : "views/templates/modals/confirmPublishAction.html",
                controller: "ConfirmDeleteActionModalController",
            });
            modalInstance.result.then(function () {
                mediaService.changeGroupStatus({ids: $scope.filterOptions.selectedItems, status: $scope.filterOptions.status === 'published' ? 'archive' : 'published'}).then(
                    function (response) {
                        if (response.status === "ok") {
                            $scope.filterOptions.selectedItems.length = 0;
                            $scope.filterOptions.status === 'published' ? logger.logSuccess("Selected images have been successfully archived") : logger.logSuccess("Selected images have been successfully published");
                            $scope.updateList()
                        } else {
                            errorHandler(response.message)
                        }
                    },
                    function (response) {
                        errorHandler(response.message)
                    }
                )
            });
        };

        /**
         * Select media
         */
        $scope.selectMedia = function selectMedia(media) {
            if (!$scope.filterOptions.isMultiselect) {
                return;
            }
            var foundIndex = -1;
            for (var i = $scope.filterOptions.selectedItems.length; i--;) {
                if ($scope.filterOptions.selectedItems[i] === media.id) {
                    foundIndex = i;
                    break;
                }
            }
            if (foundIndex !== -1) {
                $scope.filterOptions.selectedItems.splice(foundIndex, 1);
            } else {
                $scope.filterOptions.selectedItems.push(media.id);
            }
        };

        /**
         * Copy to clipboard given string
         * @param str
         */
        $scope.copyToClipboard = function copyToClipboard(str) {
            Utils.copyToClipboard(str);
            $timeout(function () {
                logger.logSuccess("Image URL successfully copied to clipboard")
            }, 100);
        };

    }
]);
